<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full  vx-row no-gutter justify-center items-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">
      <vx-card no-shadow  v-if="!isLoading">

        <div class="vx-card__title mb-6">
<!--          <h2 class="text-center" v-if="!isLoading">{{message}} !</h2>-->
        </div>

        <img src="@/assets/images/logo/its_logo_horizontal.png" alt="coming-soon" class="mx-auto mb-16 mt-16" width="250">

<!--        <div class="count-down text-center">-->
<!--          <countdown :time="new Date('03/09/2021 00:00:00').getTime() - new Date().getTime()">-->

<!--            <template slot-scope="props">-->

<!--              <div class="single-counter">-->
<!--                <span class="timer">{{ props.days }}</span>-->
<!--                <span>Days</span>-->
<!--              </div>-->

<!--              <div class="single-counter">-->
<!--                <span class="timer">{{ props.hours }}</span>-->
<!--                <span>Hours</span>-->
<!--              </div>-->

<!--              <div class="single-counter">-->
<!--                <span class="timer">{{ props.minutes }}</span>-->
<!--                <span>Minutes</span>-->
<!--              </div>-->

<!--              <div class="single-counter">-->
<!--                <span class="timer">{{ props.seconds }}</span>-->
<!--                <span>Seconds</span>-->
<!--              </div>-->

<!--            </template>-->
<!--          </countdown>-->
<!--        </div>-->

<!--        <vs-divider position="center" class="mt-16 mb-8"></vs-divider>-->

        <div class="subscription">

<!--          <span>If you would like to be notified when our app is live, Please subscribe to our mailing list.</span>-->
<!--          <vs-input type="email" label-placeholder="Email" v-model="value1" class="w-full mb-4" />-->
<!--          <vs-button :to="'/pages/login'" class="w-full">Back to Login</vs-button>-->

        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
  import VueCountdown from '@chenfengyuan/vue-countdown'
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import store from "../../store/store";
  const StaffRepository = RepositoryFactory.get('staff');
  const UserRepository = RepositoryFactory.get('user');

  export default {
    data () {
      return {
        value1: '',
        code: this.$route.params.code,
        userNotFound: false,
        isLoading: true,
        message: ''
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    async mounted() {
      // const is_logged = store.getters.currentUser
      await this.checkVerification();
    },
    components: {
      'countdown': VueCountdown
    },
    methods: {
      async checkVerification() {
        this.isLoading = true
        try {
          const data =  await UserRepository.accountVerify(this.code)
          this.userNotFound = false
          this.message = 'Your account Verified'
          this.isLoading = false
          this.$vs.loading.close()
          this.showSuccessMessage('Your account verified!')
          this.$router.push('/pages/login')
        } catch (e) {
          this.userNotFound = true
          this.message = e.response.data.message
          this.isLoading = false
          this.$vs.loading.close()
          this.showErrorMessage(this.message)
          this.$router.push('/pages/login')
          // this.convertAndNotifyError(e)
        }


      }
    }
  }

</script>

